<template>
  <a-select
    showSearch
    v-model="localValue"
    :placeholder="placeholder"
    @change="onChange"
    :style="{ width }"
    optionFilterProp="children"
    :filterOption="filterOption"
  >
    <svg slot="suffixIcon" width="9px" height="7px" viewBox="0 0 9 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(0.000000, -2.000000)" fill="#51C6E5">
          <path d="M5.39585148,7.80027269 C5.05395635,8.23619432 4.49616361,8.2318382 4.15918828,7.80227313 L1.05893763,3.8501755 C0.375364939,2.97877951 0.719300817,2.27092074 1.82924133,2.2691253 L7.73597305,2.25957052 C8.84497273,2.2577766 9.19343873,2.95828966 8.5097655,3.8299837 L5.39585148,7.80027269 Z" id="triangle"></path>
        </g>
      </g>
    </svg>
    <slot></slot>
  </a-select>
</template>

<script>
  import { noop } from 'lodash'

  export default {
    name: 'SearchableDropdown',
    props: {
      placeholder: {
        required: true,
        type: String
      },
      onChange: {
        type: Function,
        default: noop
      },
      width: {
        type: String,
        default: '150px'
      },
      value: {
        type: String,
        required: false
      }
    },
    computed: {
      localValue: {
        get() {
          return this.value
        },
        set(localValue) {this.$emit('input', localValue)}
      }
    },
    methods: {
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      }
    }
  }
</script>

<style lang="stylus">
  @import '../styles/dropdown'
</style>
